export default {
	addGlobalPosts(state, payload) {
		state.globalPosts.push(payload);
	},
	setGlobalPosts(state, payload) {
		state.globalPosts = payload;
	},
	deletedGlobalPost(state, payload) {
		const deletedPost = state.globalPosts.find((post) => post.id === payload);
		const index = state.globalPosts.indexOf(deletedPost);
		state.globalPosts.splice(index, 1);
	},
	addLeaguePosts(state, payload) {
		state.leaguePosts.push(payload);
	},
	setLeaguePosts(state, payload) {
		state.leaguePosts = payload;
	},
	deletedLeaguePost(state, payload) {
		const deletedPost = state.leaguePosts.find((post) => post.id === payload);
		const index = state.leaguePosts.indexOf(deletedPost);
		state.leaguePosts.splice(index, 1);
	},
	addTeamPosts(state, payload) {
		state.teamPosts.push(payload);
	},
	setTeamPosts(state, payload) {
		state.teamPosts = payload;
	},
	deletedTeamPost(state, payload) {
		const deletedPost = state.teamPosts.find((post) => post.id === payload);
		const index = state.teamPosts.indexOf(deletedPost);
		state.teamPosts.splice(index, 1);
	},
};